import React from "react";

const UniformCardGrid = ({ items, showButton = false, onClicked }) => {
  if (!items || items.length === 0) {
    return <div className="text-center py-10 text-gray-500">No blog content available.</div>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 px-6">
      {items.map((item, index) => (
        <div
          key={item.id || index}
          className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-transform hover:-translate-y-1 duration-300 h-auto flex flex-col mb-10"
        >
          <div className="w-full aspect-square overflow-hidden">
            <img
              src={item.preview_image_url}
              alt={item.title}
              className="w-full h-full object-cover rounded-t-xl"
            />
          </div>
          <div className="px-6 pt-4 pb-6 flex-grow flex flex-col justify-between text-left">
            <div className="ml-2 mt-2">
              <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">
                {item.description}
              </p>
            </div>
            {showButton && (
              <div>
                <button
                  onClick={() => onClicked?.(item.id || "")}
                  className="mt-4 ml-2 text-sm font-medium text-black py-2"
                >
                  See More →
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UniformCardGrid;
